import { render, staticRenderFns } from "./MobileBanner.vue?vue&type=template&id=c0aefec0&scoped=true&"
import script from "./MobileBanner.vue?vue&type=script&lang=js&"
export * from "./MobileBanner.vue?vue&type=script&lang=js&"
import style0 from "./MobileBanner.vue?vue&type=style&index=0&id=c0aefec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0aefec0",
  null
  
)

export default component.exports